"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Services = require('./services');

module.exports = function RecognitionAnywhereSdk(context) {
  var _this = this;

  _classCallCheck(this, RecognitionAnywhereSdk);

  if (!context) {
    throw new Error('context is required');
  }

  if (!context.fetch) {
    throw new Error('contextual fetch is required');
  }

  this.context = context;
  context.services = new Services(context);
  Object.keys(context.services).forEach(function (service) {
    _this[service] = context.services[service];
  });
  this.assets = {
    recognitionNow: {
      icon: 'https://api.biw.cloud/v1/images/b9d39933-2ebb-456e-8035-4d1d082d9f09',
      primaryBlack: 'https://api.biw.cloud/v1/images/70f87e93-24b8-40bf-bb86-fe3d36bedc2d',
      primaryColor: 'https://api.biw.cloud/v1/images/2a66aec5-bb58-4628-bed6-3faea0137c0b',
      primaryWhite: 'https://api.biw.cloud/v1/images/9540bae2-25c4-499d-b3bc-727af0fc1a03',
      secondaryBlack: 'https://api.biw.cloud/v1/images/10d18b2f-ce46-4737-964e-4181378a1ad5',
      secondaryColor: 'https://api.biw.cloud/v1/images/25d2b640-3a25-4e71-9364-515eeb3f86d0',
      secondaryWhite: 'https://api.biw.cloud/v1/images/e6787fb9-c34e-42cc-a1d9-99dd20c7432f'
    }
  };
};
//# sourceMappingURL=index.js.map